import {forEach, IComponentOptions} from "angular";
import {Credit} from "../model/Credit";
import {Assessment} from "../model/Assessment";
import {Application} from "../model/Application";
import {IReferenceDataItem, ReferenceData} from "../reference-data/reference-data.service";
import {ApplicationService} from "../application/application.service";
import {StudyUnitService} from "../study-unit/study-unit.service";

import "./assessment.less";
import {CparService} from "../cpar/cpar.service";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {CreditRecord} from "../model/CreditRecord";


class CreditComponentController {
    public modalInstance: IModalInstanceService;
    public fieldsEnabled: boolean;
    public form: any;
    public resolve: any;
    public assessmentTypes: IReferenceDataItem[];
    public specifiedCreditTypes: IReferenceDataItem[];
    public unspecifiedCreditTypes: IReferenceDataItem[];
    public assessment: Assessment;
    public application: Application;
    public priorUnits: any;
    public credit: Credit;
    public unitLevels: IReferenceDataItem[];
    public showErrors: boolean = false;
    public actionsEnabled: boolean;
    public hideCreditPoints: boolean;

    /* @ngInject */
    constructor(
        private $log: ng.ILogService,
        private applicationService: ApplicationService,
        private $uibModal: any,
        private studyUnitService: StudyUnitService,
        private cparService: CparService,
        private referenceData: ReferenceData) {

        this.assessmentTypes = this.referenceData.getAll("AssessmentType");
        this.specifiedCreditTypes = this.referenceData.getAll("SpecifiedCreditType");
        this.unspecifiedCreditTypes = this.referenceData.getAll("UnspecifiedCreditType");
        this.unitLevels = this.referenceData.getAll("UnitLevel");
    }

    public $onInit() {
        this.$log.debug("CreditComponentController.$onInit()");
        this.credit = this.resolve.credit;
        if (this.credit === undefined || this.credit === null) {
            this.credit = new Credit();
        }
        this.assessment =  this.resolve.assessment;
        this.application =  this.resolve.application;
        this.priorUnits =  this.resolve.priorUnits;
        this.fieldsEnabled =  this.resolve.fieldsEnabled;
        this.showErrors =  this.resolve.showErrors;
        this.hideCreditPoints = this.credit.specifiedCreditType === "PRECLUSION";
    }


    public specifiedCreditTypeChanged(credit: Credit) {
        this.$log.debug("specifiedCreditTypeChanged", credit.monashUnitCode);
        this.hideCreditPoints = this.credit.specifiedCreditType === "PRECLUSION";
    }


    private assessmentTypeChange(credit: Credit) {
        this.$log.log("Assessment type changed");
        const type = credit.type;
        if (type !== "UNSPECIFIED_CREDIT") {
            this.clearUnspecifiedCreditTypeFields(credit);
        }
        if (type !== "SPECIFIED_CREDIT") {
            this.clearSpecifiedCreditTypeFields(credit);
        }
    }

    private getUnitDescription(unitLevel: string){
        const units = this.unitLevels.filter((unit) => unit.id === "UNIT_LEVEL_"+unitLevel);
        if(units.length != 1){
            this.$log.error("Something wrong with the unit level")
            return "undefined unit level"
        }
        return units[0].description;
    }

    private getCourseName(courseCode: string){
        const appliedCourse = this.application.coursesApplied.filter((course) => course.courseCode == courseCode.split('-',1)[0])
        if (appliedCourse.length != 1) {
            return "Undefined course. Please contact administrator."
        }
        const courseInfo = appliedCourse[0].course;
        return appliedCourse[0].course.title;
    }

    private hasExistedCreditForSelectedCourse(courseCodes: string[]){
        if (!this.application.applicant.creditRecords){
            return false;
        }
        return courseCodes.filter(s => this.getRelevantCreditForCourse(s).length > 0).length > 0;
    }

    private isExistingCreditChangeable(){
        return this.application.status == "SUBMITTED" || this.application.status == "UNDER_ASSESSMENT"
            || this.application.status == "REOPENED";
    }

    private getRelevantCreditForCourse(courseCode: string){
        if (!this.application.applicant.creditRecords){
            return [];
        }
        return this.application.applicant.creditRecords
            // filter those creditRecords based on the selected course
            .filter((credit) => courseCode.split('-', 1)[0] == credit.courseCode);
    }

    private getUnitLevelOrCode(credit: CreditRecord){
        return credit.creditType == "unspecifiedCredit" ? "Level: " + credit.unitLevel : credit.unitCode;
    }

    private getCustomCreditType(creditType: string){
        if (creditType != null){
            return creditType.substring(0, creditType.length - 6);
        }
        return "undefined creditType, please contact administrator";
    }

    private searchUnit(unitName) {
        return this.priorUnits.filter((el) => {
            return el.unitTitle.toLowerCase().indexOf(unitName) > -1;
        });
    }

    private clearUnspecifiedCreditTypeFields(credit: Credit) {
        this.$log.log("clearUnspecifiedCreditTypeFields");
     //   credit.unspecifiedCreditType = null;
        credit.unitLevel = null;
        credit.discipline = null;
    }

    private clearSpecifiedCreditTypeFields(credit: Credit) {
        this.$log.log("clearSpecifiedCreditTypeFields");
      //  credit.specifiedCreditType = null;
        credit.monashUnitCode = null;
        credit.monashUnitVersion = null;
    }

    private ok() {
        this.$log.log("ok");
        if (this.form.$invalid) {
            this.setTouched(this.form.$$controls);
            this.showErrors = true;
        } else {
            this.modalInstance.close({$value: this.credit});
        }
    }

    private setTouched(controls) {
        this.$log.log("setTouched");
        forEach(controls, (control) => {
            if (control.$setTouched !== undefined) {
                control.$setTouched();
            }

            if (control.$$controls !== undefined) {
                this.setTouched(control.$$controls);
            }
        });
    }

    private close() {
        this.modalInstance.dismiss("Cancelled");
    }
}

export const CreditComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "="
    },
    controller: CreditComponentController,
    controllerAs: "vm",
    template: require("./credit.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/credit.component.ts